export default __webpack_public_path__ + "static/media/Banner2.434a961f.webp";